var React = require('react');

function TriangleLeft (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"fill":"#26A693","fillRule":"evenodd","points":"67.62 34 136 138 0 138","opacity":".8","transform":"translate(0 -34)"}));
}

TriangleLeft.defaultProps = {"width":"136","height":"104","viewBox":"0 0 136 104"};

module.exports = TriangleLeft;

TriangleLeft.default = TriangleLeft;
